import { Hexagon, NotebookPen, BarChart3 } from "lucide-react";

const STEPS = [
  {
    n: 1,
    icon: Hexagon,
    title: "Add your hives",
    body: "Set up each colony in under a minute — yard, hive type, queen color, installation date. Add a photo and a hex colour to spot it in the grid.",
  },
  {
    n: 2,
    icon: NotebookPen,
    title: "Log inspections in seconds",
    body: "Dictate notes by voice or tap the quick form. We auto-fill observations, mood and weather so your gloves stay on the box, not the keyboard.",
  },
  {
    n: 3,
    icon: BarChart3,
    title: "Trends, treatments & nudges follow",
    body: "We crunch your journal data into health trends, schedule follow-up reminders, and surface seasonal prompts when your bees need them.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="spy-how"
      className="relative max-w-6xl mx-auto px-6 py-24"
      data-testid="landing-how-it-works"
    >
      <header className="text-center max-w-2xl mx-auto mb-14">
        <div className="text-xs font-semibold uppercase tracking-[0.25em] text-amber-700 mb-3">How it works</div>
        <h2 className="font-display text-4xl sm:text-5xl font-light tracking-tight text-stone-900">
          From sticky notes to a real beekeeping system in 3 steps.
        </h2>
      </header>
      <ol className="grid md:grid-cols-3 gap-8">
        {STEPS.map((s) => (
          <li
            key={s.n}
            className="relative bg-gradient-to-b from-amber-50/40 to-white border border-stone-200 rounded-3xl p-7"
            data-testid={`how-step-${s.n}`}
          >
            <div className="absolute -top-4 left-7 w-9 h-9 rounded-full bg-stone-900 text-amber-200 grid place-items-center font-display text-lg font-bold">
              {s.n}
            </div>
            <div className="w-12 h-12 rounded-2xl bg-amber-500 text-stone-950 grid place-items-center mb-4 mt-2">
              <s.icon className="w-6 h-6" />
            </div>
            <h3 className="font-display text-2xl font-medium text-stone-900 mb-2">{s.title}</h3>
            <p className="text-sm text-stone-600 leading-relaxed">{s.body}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
